import {client} from '../helpers/api';

export async function postCheckEmail({email}) {
  const body = {email};

  const response = await client.post('/api/check-email', body);

  if (response.data?.status) {
    if (!response.data?.is_user) {
      return;
    }
    throw 'User Exist';
  }
  throw response;
}
